/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import HeadTittle from "../../../../../../components/HeadTittle";
import DivContainerBody from "../../../../../../components/DivContainerBody";
import {permissionObj} from "../../../../../../Helpers/permission";
import routes from "../../../../../../Routes/routes";
import EntryAndExitFormDetailsSectionInfo from "../../EntryAndExitForms/Details/EntryAndExitFormDetailsSectionInfo";
import VehicleMovementGateLogSection from "./VehicleMovementGateLogSection";
import DiscrepancySection from "../../EntryAndExitForms/Details/Sections/DiscrepancySection";
import StatusBadgeSection from "../../EntryAndExitForms/Details/Sections/StatusBadgeSection";
import VehicleMovementDetailsApp from "../../../Functionality/VehicleMovements/VehicleMovementDetailsApp";
import {getVehicleMovementDetailsSections} from "../../../Model/Model";

/**
 * Detail of a movement of a vehicle.
 *
 * The information the requester registered is read in the same card the entry
 * and exit forms are read with, and the gate log holds the vehicle and the
 * moment the guard registered it.
 *
 * @returns {JSX.Element} Detail of the movement.
 */
const VehicleMovementDetails = () => {
    const {
        t,
        navigate,
        DEV,
        isGuard,
        permission,
        item,
        evidence,
        statusId,
        pendingGateTrans,
        showBadge,
        badgeItem,
        hasDiscrepancies,
        discrepancyFiles,
        vehicleDirectionOption,
        containerCardRef,
        contentCardRef,
        containerTableRef,
        contentTableRef,
        goBack
    } = VehicleMovementDetailsApp();

    if (!DEV && !isGuard &&
        !permission?.includes(permissionObj.WEB_VEHICLE_MOVEMENTS_READ)
    )
        navigate(routes.forbidden);

    const sections = getVehicleMovementDetailsSections(item);

    return (
        <>
            <HeadTittle name={'details'} onBack={goBack}/>
            <DivContainerBody>
                <div className={"mb-4"}>
                    <StatusBadgeSection
                        t={t}
                        item={badgeItem}
                        showBadge={showBadge}
                        pendingTrans={pendingGateTrans}
                    />
                </div>

                <div className='row px-0'>
                    <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0 pr-sm-0 pr-md-3'
                         ref={containerCardRef}>
                        <EntryAndExitFormDetailsSectionInfo
                            item={item}
                            evidence={evidence}
                            sections={sections}
                            statusId={statusId}
                            movementType={vehicleDirectionOption}
                            contentCardRef={contentCardRef}
                        />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-8 px-0' ref={containerTableRef}>
                        {hasDiscrepancies &&
                            <div className={"mb-3"}>
                                <DiscrepancySection
                                    t={t}
                                    reviewedBy={badgeItem?.dispatchUser}
                                    reviewedAt={badgeItem?.dispatchDate}
                                    reason={badgeItem?.dispatchReason}
                                    files={discrepancyFiles}
                                />
                            </div>
                        }

                        <VehicleMovementGateLogSection
                            t={t}
                            item={item}
                            directionOption={vehicleDirectionOption}
                            contentRef={contentTableRef}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default VehicleMovementDetails;
